// sublayout dashbordu - menu w sidebarze

import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Grid } from '@mui/material';
import classnames from 'classnames';
import { Helmet } from 'react-helmet';

import { useAppNavigate } from 'hooks';
import { useSelector } from 'store';

import { HeaderTopBar, BottomMenu } from 'components/layouts/MainLayout/components';

import { DashboardMenu } from 'plugins/components/containers';

import styles from 'plugins/theme/components/ManagmentPanelLayout/ManagmentPanelLayout.module.scss';

const ManagementPanelLayout = () => {
  const navigate = useAppNavigate();

  const { profile } = useSelector((state) => state.auth);

  useEffect(() => {
    if (profile?.role === 'ROLE_OPEN_PROFILE') {
      navigate('/');
    }
  }, [profile]);

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.13.1/font/bootstrap-icons.min.css"
        />
      </Helmet>
      <div
        className={classnames(
          styles.componentWrapper,
          'StylePath-Components-Layouts-ManagmentPanelLayout'
        )}>
        <main>
          <header>
            <HeaderTopBar simpleHeader={false} isAdminPanel />
          </header>
          <div className={styles.content}>
            <Grid container>
              <Grid item md={2} xs={12} className={styles.menuWrapper}>
                {profile?.role && <DashboardMenu isAdminPanel />}
              </Grid>
              <Grid item md={10} xs={12} className={styles.pageContent}>
                <Outlet />
              </Grid>
            </Grid>
          </div>
          <BottomMenu />
        </main>
      </div>
    </>
  );
};

export default ManagementPanelLayout;
